import * as React from "react";
import { Link, makeStyles, Box, useTheme } from "@material-ui/core";
import { Theme } from "../.themes";

const useStyles = makeStyles((theme: Theme) => ({
  checkoutLink: {
    lineHeight: "36px",
    color: theme.checkoutLinks?.color,
    margin: `${theme.spacing(2)}px 0`,
    ...theme.CheckoutPage?.links,
  },
  checkoutLinksBlock: {
    textAlign: theme.checkoutLinks?.textAlign ?? "center",
    marginBottom: theme.spacing(5),
    marginTop: -theme.spacing(3),
  },
}));

export type CheckoutPageBottomLinkProps = {
  checkoutExtraUrl1?: {
    link?: string;
    urlText?: string;
  };
  checkoutExtraUrl2?: {
    link?: string;
    urlText?: string;
  };
};

const CheckoutPageBottomLinkBase: React.FC<CheckoutPageBottomLinkProps> = (props: CheckoutPageBottomLinkProps) => {
  const css = useStyles(useTheme());

  return (
    <Box className={css.checkoutLinksBlock}>
      {props.checkoutExtraUrl1?.link && (
        <Link className={css.checkoutLink} href={props.checkoutExtraUrl1?.link} target='_blank' color='inherit' variant='body1'>
          {props.checkoutExtraUrl1?.urlText}
        </Link>
      )}
      <br />
      {props.checkoutExtraUrl2?.link && (
        <Link className={css.checkoutLink} href={props.checkoutExtraUrl2?.link} target='_blank' color='inherit' variant='body1'>
          {props.checkoutExtraUrl2?.urlText}
        </Link>
      )}
    </Box>
  );
};

export default CheckoutPageBottomLinkBase;
